const SESSION_KEY = "corisco-sessao-navegacao";
const ID_SEGMENT = /^(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

/** "/vagas/2feb…/editar" → "/vagas/:id/editar". Nunca grava id de registro. */
export function routePattern(pathname: string): string {
  const pattern = pathname
    .split("/")
    .map((segment) => (ID_SEGMENT.test(segment) ? ":id" : segment))
    .join("/");
  return pattern.length > 1 ? pattern.replace(/\/$/, "") : pattern;
}

export function sessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = Math.random().toString(36).slice(2, 12);
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "sem-storage";
  }
}
